import { axios } from "../api/axios";

export const validateReferrerToken = async (streamId: any) => {
    return axios.get(`/authentication/referrer/validate?stream_id=${streamId}`);
}
